import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import PublicNavbar from "@/components/layout/PublicNavbar";

export default function CustomerSupportPage() {
  return (
    <>
      <PublicNavbar />
      <div className="min-h-screen bg-agent-background text-agent-text pt-16">
        <div className="py-20 px-4 sm:px-6 lg:px-8">
          <div className="max-w-5xl mx-auto">
            <h1 className="text-4xl md:text-6xl font-bold mb-6">
              <span className="text-agent-primary">AI Customer</span> Support
            </h1>
            <p className="text-xl text-agent-muted mb-12">
              Provide instant, 24/7 customer support with AI agents that can
              understand and resolve customer inquiries naturally and
              efficiently.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
              <div className="bg-agent-card border border-agent-border p-8 rounded-xl">
                <h2 className="text-2xl font-bold mb-4">Key Features</h2>
                <ul className="space-y-4">
                  <li className="flex items-center">
                    <div className="h-2 w-2 rounded-full bg-agent-primary mr-3"></div>
                    <span>24/7 availability</span>
                  </li>
                  <li className="flex items-center">
                    <div className="h-2 w-2 rounded-full bg-agent-primary mr-3"></div>
                    <span>Multi-language support</span>
                  </li>
                  <li className="flex items-center">
                    <div className="h-2 w-2 rounded-full bg-agent-primary mr-3"></div>
                    <span>Natural conversations</span>
                  </li>
                  <li className="flex items-center">
                    <div className="h-2 w-2 rounded-full bg-agent-primary mr-3"></div>
                    <span>Instant responses</span>
                  </li>
                </ul>
              </div>

              <div className="bg-agent-card border border-agent-border p-8 rounded-xl">
                <h2 className="text-2xl font-bold mb-4">Benefits</h2>
                <ul className="space-y-4">
                  <li className="flex items-center">
                    <div className="h-2 w-2 rounded-full bg-agent-secondary mr-3"></div>
                    <span>Reduce support costs</span>
                  </li>
                  <li className="flex items-center">
                    <div className="h-2 w-2 rounded-full bg-agent-secondary mr-3"></div>
                    <span>Improve response times</span>
                  </li>
                  <li className="flex items-center">
                    <div className="h-2 w-2 rounded-full bg-agent-secondary mr-3"></div>
                    <span>Increase customer satisfaction</span>
                  </li>
                  <li className="flex items-center">
                    <div className="h-2 w-2 rounded-full bg-agent-secondary mr-3"></div>
                    <span>Scale support operations</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="text-center">
              <Link to="/signup">
                <Button className="bg-agent-primary hover:bg-agent-primary/80 text-black font-medium px-8 py-6 text-lg">
                  Get Started
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
